// Principal.js
import React from 'react';
import Banner from './banner';
import Eventos from './eventos';


const Principal = () => {
  return (
    <div>
      <Banner />
      <Eventos />
    </div>
  );
};

export default Principal;



